import React from "react";
import { iconProps } from "../Helper";

const ProIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clip-path="url(#clip0_17477_202515)">
        <path
          d="M6.66645 14.1573L4.50311 9.83L0.175781 7.66667L4.50311 5.50333L6.66645 1.176L8.82978 5.50333L13.1571 7.66667L8.82978 9.83L6.66645 14.1573ZM3.15711 7.66667L5.49645 8.83667L6.66645 11.176L7.83645 8.83667L10.1758 7.66667L7.83645 6.49667L6.66645 4.15733L5.49645 6.49667L3.15711 7.66667ZM11.9998 14L12.9998 16L13.9998 14L15.9998 13L13.9998 12L12.9998 10L11.9998 12L9.99978 13L11.9998 14ZM12.8884 3.11133L13.6664 4.66667L14.4444 3.11133L15.9998 2.33333L14.4444 1.55533L13.6664 0L12.8884 1.55533L11.3331 2.33333L12.8884 3.11133Z"
          className={className}
        />
      </g>
      <defs>
        <clipPath id="clip0_17477_202515">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ProIcon;
